
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  name: 'IndexPage',
  auth: false,
  async fetch() {
    const resStats = await this.getHomePageStats()

    if (resStats) {
      this.counterItem = resStats.data
    }

    await Promise.all([
      this.loadPropertyPage(161, 1),
      this.loadPropertyPage(162, 1),
    ])
  },
  data: () => ({
    parmsForPropertyForSale: {
      page: 1,
      itemsPerPage: 10,
      sorted: true,
      type: 161,
    },

    parmsForPropertyForRent: {
      page: 1,
      itemsPerPage: 10,
      sorted: true,
      type: 162,
    },

    propertyItemSale: [],
    propertyItemRent: [],

    salePageInfo: null,
    rentPageInfo: null,

    loadingSale: false,
    loadingRent: false,

    // keep all your other existing data below
    showProperdiMoved: false,
    imgSrc: require("~/assets/img/We've moved_en.png"),
    propertyTypeId: null,
    showType: false,
    showPrice: false,

    items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    expand: false,
    showSchedule: false,
    showMap: false,
    areaSelected: null,
    selectFromMap: false,
    form: false,
    keyword: null,
    loading: false,

    counterItem: [
      { name: 'Listed Properties', value: '0' },
      { name: 'Property Agents', value: '0' },
      { name: 'Average Rent/Mo', value: '0' },
    ],

    selectedSearchTab: 'For Sale',

    minPrice: {
      name: null,
      value: null,
      displayValue: null,
    },

    maxPrice: {
      name: null,
      value: null,
      displayValue: null,
    },

    showdemodialog: false,
    showdemodialogTh: false,

    latLng: {
      lat: 13.7563,
      lng: 100.5018,
    },

    formattedAddress: null,
    showPopupsContactForm: false,
    placeId: null,
  }),
  watch: {
    '$i18n.locale'() {
      console.log(this.$i18n.locale)
      this.imgSrc = require(`~/assets/img/We\'ve moved_${this.$i18n.locale}.png`)
    },
    selectedSearchTab() {
      // this.$nextTick(()=>{
      //   this.range= [this.selectedSearchTab==='For Sale'?100000 :1000, this.selectedSearchTab==='For Sale'? 250000000:500000]
      // })
    },
  },
  mounted() {
    // if (window.location.origin == 'https://properdee.com') {
    //     this.showProperdiMoved=true
    //   } else {
    //     return false
    //   }
    // this.$nextTick(()=>{
    //   this.range= [this.selectedSearchTab==='For Sale'?100000 :1000, this.selectedSearchTab==='For Sale'? 250000000:500000]
    // })
    if (this.$route.query.landingPage) {
      this.showPopupsContactForm = true
    }
  },
  computed: {
    ...mapState('config/site', ['siteConfig']),
    ...mapState('taxonomy', ['taxonomy']),
  },
  methods: {
    ...mapActions('home', ['getPropertyList', 'getHomePageStats', 'search']),
    // ...mapMutations('home', ['setSearchParams']),
    // ...mapActions('home', ['getPropertyList']),

    // goto() {
    //   window.open('https://properdi.com', '_self')
    // },
    searchForProperties() {
      const obj = {
        polygon: [
          {
            lat: 0,
            lng: 0,
          },
        ],
        location: this.latLng,
        propertyListingTypeId:
          this.selectedSearchTab === 'For Sale' ? 161 : 162,
        propertyTypeId: this.propertyTypeId ? this.propertyTypeId.id : null,
        minPrice: this.minPrice.value,
        maxPrice: this.maxPrice.value,
      }
      // localStorage.setItem('searchObj',JSON.stringify(obj))
      let parmas = null
      if (this.keyword) {
        parmas = `?keyword=${
          this.keyword ? this.keyword : ''
        }&propertyListingTypeId=${
          this.selectedSearchTab === 'For Sale' ? 161 : 162
        }&propertyTypeId=${this.propertyTypeId.id}&minPrice=${
          this.minPrice.value
        }&maxPrice=${this.maxPrice.value}&lat=null&lng=null`
      } else {
        parmas = `?lat=${this.latLng.lat}&lng=${
          this.latLng.lng
        }&propertyListingTypeId=${
          this.selectedSearchTab === 'For Sale' ? 161 : 162
        }`
      }
      if (this.minPrice.value) {
        parmas = parmas + `&minPrice=${this.minPrice.value}`
      }
      if (this.minPrice.value) {
        parmas = parmas + `&maxPrice=${this.maxPrice.value}`
      }
      if (this.propertyTypeId) {
        parmas = parmas + `&propertyTypeId=${this.propertyTypeId.id}`
      }
      if (this.placeId) {
        parmas = parmas + `&placeId=${this.placeId}`
      }
      window.open(
        `${this.$i18n.locale == 'en' ? '/en' : ''}/search${parmas}`,
        '_self'
      )
      //this.$router.push(this.localeRoute(`/search?lat=${this.latLng.lat}&lng=${this.latLng.lng}`))
    },
    mapAreaSelected(ev) {
      console.log('mapAreaSelected', ev)
      this.areaSelected = ev
      this.showMap = false
      switch (this.areaSelected) {
        case 'Central':
          this.latLng = { lat: 13.7563, lng: 100.5018 }
          break
        case 'North-East':
          this.latLng = { lat: 16.4325, lng: 102.8233 }
          break
        case 'North':
          this.latLng = { lat: 18.7883, lng: 98.9853 }
          break
        case 'East':
          this.latLng = { lat: 12.9236, lng: 100.8824 }
          break
        case 'South':
          this.latLng = { lat: 7.9843, lng: 98.3307 }
          break
        case 'West':
          this.latLng = { lat: 12.5684, lng: 99.9577 }
          break
      }
      this.searchForProperties()
    },
    onSubmit(ev) {},
    mapChangesFromAutoComplete(ev) {
      console.log('mapChangesFromAutoComplete', ev)
      ;(this.placeId = ev),
        console.log('mapChangesFromAutoComplete', this.latLng)
    },

    async loadPropertyPage(type, page) {
      const isSale = type === 161

      const params = isSale
        ? this.parmsForPropertyForSale
        : this.parmsForPropertyForRent

      if (isSale) {
        if (this.loadingSale) return
        this.loadingSale = true
      } else {
        if (this.loadingRent) return
        this.loadingRent = true
      }

      try {
        const res = await this.getPropertyList({
          ...params,
          page,
          type,
        })

        if (!res || !res.success) {
          return
        }

        if (isSale) {
          this.propertyItemSale = res.data || []
          this.salePageInfo = res.pageInfo
          this.parmsForPropertyForSale.page = page
        } else {
          this.propertyItemRent = res.data || []
          this.rentPageInfo = res.pageInfo
          this.parmsForPropertyForRent.page = page
        }
      } catch (error) {
        console.error(`Failed loading ${type} properties`, error)
      } finally {
        if (isSale) {
          this.loadingSale = false
        } else {
          this.loadingRent = false
        }
      }
    },

    nextPropertyPage(type) {
      const pageInfo = type === 161 ? this.salePageInfo : this.rentPageInfo

      if (!pageInfo) return

      const nextPage = pageInfo.currentPage + 1

      if (nextPage > pageInfo.pages) {
        return
      }

      this.loadPropertyPage(type, nextPage)
    },

    previousPropertyPage(type) {
      const pageInfo = type === 161 ? this.salePageInfo : this.rentPageInfo

      if (!pageInfo) return

      const previousPage = pageInfo.currentPage - 1

      if (previousPage < 1) {
        return
      }

      this.loadPropertyPage(type, previousPage)
    },

    // keep your existing methods below

    goto() {
      window.open('https://properdi.com', '_self')
    },
  },
  head() {
    return {
      title: 'Properdee',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'Properdee',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: `Properdee`,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: '',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `${this.origin}${this.$route.fullPath}`,
        },
        // Twitter
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: 'Properdee',
        },
        {
          hid: 'twitter:description',
          property: 'twitter:description',
          content: 'Properdee',
        },
        {
          hid: 'twitter:image',
          property: 'twitter:image',
          content: 'Properdee',
        },
        {
          hid: 'twitter:url',
          property: 'twitter:url',
          content: `${this.origin}${this.$route.fullPath}`,
        },
      ],
    }
  },
}
